// Bus d'actualisation des données (même session).
// Après une opération CRUD réussie (création / modification / suppression /
// changement de statut) dans un module, celui-ci émet l'évènement ; les vues
// partagées (Pilotage : compteurs d'onglets, calendrier, sélecteurs de
// véhicules) se rechargent automatiquement, sans rafraîchissement manuel du
// navigateur et sans réinitialiser les filtres/recherches/dates en cours.
//
// Volontairement minimal : aucun temps réel généralisé, aucun polling permanent.
const EVT = "jn:data-changed";

export function emitDataChanged(resources = []) {
  const list = Array.isArray(resources) ? resources : [resources];
  window.dispatchEvent(new CustomEvent(EVT, { detail: { resources: list } }));
}

export function onDataChanged(handler) {
  const cb = (e) => handler((e.detail && e.detail.resources) || []);
  window.addEventListener(EVT, cb);
  return () => window.removeEventListener(EVT, cb);
}
